'use client';
import React, { createContext, useReducer, useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { initialState, authReducer } from './authReducer';

const AuthContext = createContext();

export const useAuthContext = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const [dashboardHeaderTitle, setDashboardHeaderTitle] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const value = useMemo(
    () => ({
      state,
      dispatch,
      dashboardHeaderTitle,
      setDashboardHeaderTitle,
      authLoading,
      setAuthLoading,
    }),
    [state, dashboardHeaderTitle, authLoading],
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
